import { render, staticRenderFns } from "./SettingsLogs.vue?vue&type=template&id=00fd087c"
import script from "./SettingsLogs.vue?vue&type=script&lang=js"
export * from "./SettingsLogs.vue?vue&type=script&lang=js"
import style0 from "./SettingsLogs.vue?vue&type=style&index=0&id=00fd087c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports